import { toScreen } from '@doltech/core/lib/responsive/responsive.util';
import { slidingBottomToTop } from '@doltech/utils/lib/animations/slide';
import * as React from 'react';
import styled from 'styled-components';

import { Button } from '../../figma/ButtonV2/ButtonV2';
import { colorsV2 } from '../../figma/colors-v2';
import { Typography } from '../../figma/DesignSystemV2/Typography';
import { Link } from '../../figma/Link';
import imgDolEnglish from '../img/dolenglish-moment-slide.png';

const Title = styled(Typography.Text).attrs({ color: 'primary100', variant: 'bold/32' })``;
const Description = styled(Typography.Text).attrs({ color: 'black80', variant: 'regular/16-24' })``;
const ColorButton = styled(Button.Primary)`
  min-width: 200px;
`;
const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px 48px;

  ${Description} {
    margin-top: 12px;
    max-width: 374px;
  }
  ${ColorButton} {
    margin-top: 32px;
  }
`;

const SlidingImage = styled.img`
  ${slidingBottomToTop}
  width: 100%;
`;
const RightSection = styled.div`
  max-height: 240px;
`;

const RegisterCoursePromotionWrapper = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 3fr 2fr;
  background-color: ${colorsV2.primary10};
  overflow: hidden;

  ${toScreen(768)} {
    ${RightSection} {
      display: none;
    }
  }
`;
export const RegisterCoursePromotion = () => {
  return (
    <RegisterCoursePromotionWrapper>
      <LeftSection>
        <Title>Đăng ký khóa IELTS tại DOL</Title>
        <Description>
          Nhắn tin để test đầu vào và nhận tư vấn miễn phí từ DOL English - IELTS Đình Lực
        </Description>
        <Link
          href="https://m.me/dolenglish.ieltsdinhluc"
          target="_blank"
          rel="noopener noreferrer nofollow"
        >
          <ColorButton>Inbox DOL</ColorButton>
        </Link>
      </LeftSection>
      <RightSection>
        <SlidingImage loading="lazy" src={imgDolEnglish} />
        <SlidingImage loading="lazy" src={imgDolEnglish} />
      </RightSection>
    </RegisterCoursePromotionWrapper>
  );
};
